import { AsyncPipe, NgComponentOutlet, NgTemplateOutlet } from "@angular/common";
import { Component, Input, ChangeDetectionStrategy } from "@angular/core";
import { ObjectUtils } from "~app/common/utils/object-utils";
import { SafePipe } from "../../../../../../pipes/safe.pipe";
import { INode } from "../models/layer-node.model";

@Component({
    selector: "rask-layer-legend",
    templateUrl: "./layer-legend.component.html",
    styleUrls: ["./layer-legend.component.scss"],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
        NgTemplateOutlet,
        NgComponentOutlet,
        SafePipe,
        AsyncPipe
    ]
})
export class LayerLegendComponent {
    @Input() root: INode;

    useCustomLegend(node: any): boolean {
        return ObjectUtils.hasValue(node.customLegend);
    }
}
